import axios from "@/lib/axios";

export type UpdateQuizAnswerInBatchAnswer = {
  choiceId: string;
  value?: string;
  action: "ADD" | "REMOVE";
};

export type UpdateQuizAnswerInBatchRequestParams = {
  companyId: string;
  quizId: string;
  responseId: string;
  answers: Array<UpdateQuizAnswerInBatchAnswer>;
};

export type UpdateQuizAnswerInBatchResponse = void;

export const updateQuizAnswerInBatch = (
  params: UpdateQuizAnswerInBatchRequestParams,
) =>
  axios
    .put<UpdateQuizAnswerInBatchResponse>(
      `/v1/companies/${params.companyId}/application-quizzes/${params.quizId}/responses/${params.responseId}/answers`,
      params.answers,
    )
    .then((res) => res.data);
